import { render } from "./UpdateSoundtrackForm.vue?vue&type=template&id=5a0b0f4e"
import script from "./UpdateSoundtrackForm.vue?vue&type=script&lang=js"
export * from "./UpdateSoundtrackForm.vue?vue&type=script&lang=js"

import "./UpdateSoundtrackForm.vue?vue&type=style&index=0&id=5a0b0f4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__